/* Koli %50 kampanyası (2026-09-28) — kampanyalı üründe sipariş başına en fazla N koli.
   Tüm sepet yollarını tek yerden korur: kart + ürün sayfası (/cart/add), sepet sayfası (/cart/change, /cart/update),
   kayıtlı sepet geri yükleme (/cart/add.js items). Sepet açılışında sınırı aşan kalem varsa düşürür (ör. sepet bağlantısı).
   Veri: window.TT_KAMPANYA = { maxKoli, v: { "<variant_id>": <koli_adedi> } } — snippets/720-kampanya-koli50.liquid */
(function () {
  var K = window.TT_KAMPANYA;
  if (!K || !K.v || !window.fetch) return;
  var asilFetch = window.fetch.bind(window);

  function koli(vid) { return K.v[String(vid)] || 0; }
  function maxAdet(vid) { var k = koli(vid); return k ? k * K.maxKoli : 0; }
  function mesaj(vid, sepette) {
    var m = 'Kampanyalı üründe sipariş başına en fazla ' + K.maxKoli + ' koli alınabilir.';
    if (sepette) m += ' Sepetinizde bu üründen ' + Math.round(sepette / koli(vid)) + ' koli var.';
    return m;
  }

  function uyari(metin) {
    var el = document.getElementById('tt-kampanya-uyari');
    if (!el) {
      el = document.createElement('div');
      el.id = 'tt-kampanya-uyari';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;max-width:min(92vw,420px);' +
        'background:#c8102e;color:#fff;font:600 14px/1.4 inherit;padding:12px 16px;border-radius:6px;box-shadow:0 6px 20px rgba(0,0,0,.25);text-align:center';
      document.body.appendChild(el);
    }
    el.textContent = metin;
    el.style.display = 'block';
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.style.display = 'none'; }, 5000);
  }

  function sepet() {
    return asilFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function adetSepette(c, vid, haricKey) {
    return c.items.reduce(function (t, i) {
      return String(i.variant_id) === String(vid) && i.key !== haricKey ? t + i.quantity : t;
    }, 0);
  }
  function reddet(metin) {
    uyari(metin);
    return new Response(JSON.stringify({ status: 422, message: 'Kampanya sınırı', description: metin, errors: metin }),
      { status: 422, headers: { 'Content-Type': 'application/json' } });
  }
  function yol(input) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    try { return new URL(u, location.origin).pathname.replace(/\.js$/, ''); } catch (e) { return ''; }
  }
  function jsonMu(body) { return typeof body === 'string' && body.trim().charAt(0) === '{'; }

  // /cart/add — FormData (kart, ürün sayfası) ya da JSON {id,quantity} / {items:[...]} (kayıtlı sepet)
  function ekle(input, init) {
    var body = init && init.body;
    var fd = (typeof FormData !== 'undefined' && body instanceof FormData) ? body : null;
    var js = !fd && jsonMu(body) ? JSON.parse(body) : null;
    var kalemler = fd ? [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) }]
      : js ? (js.items || [{ id: js.id, quantity: parseInt(js.quantity || 1, 10) }]) : [];
    if (!kalemler.some(function (k) { return maxAdet(k.id); })) return asilFetch(input, init);
    return sepet().then(function (c) {
      var eklenen = {};
      if (kalemler.length === 1) {
        var k = kalemler[0], vid = String(k.id), mx = maxAdet(vid);
        if (mx) {
          var var_ = adetSepette(c, vid);
          if (var_ + k.quantity > mx) return reddet(mesaj(vid, var_));
        }
        return asilFetch(input, init);
      }
      // çoklu ekleme: aşan kalemi sınıra indir, sığmayanı çıkar
      var kirpildi = false;
      js.items = js.items.filter(function (k) {
        var vid = String(k.id), mx = maxAdet(vid);
        if (!mx) return true;
        var bos = mx - adetSepette(c, vid) - (eklenen[vid] || 0);
        var q = parseInt(k.quantity || 1, 10);
        if (q > bos) { q = Math.floor(Math.max(bos, 0) / koli(vid)) * koli(vid); kirpildi = true; }
        k.quantity = q; eklenen[vid] = (eklenen[vid] || 0) + q;
        return q > 0;
      });
      if (kirpildi) uyari(mesaj(''));
      if (!js.items.length) return reddet(mesaj(''));
      return asilFetch(input, Object.assign({}, init, { body: JSON.stringify(js) }));
    });
  }

  // /cart/change — {line|id, quantity}: aynı varyantın diğer kalemleriyle birlikte sınırı aşarsa düşür
  function degistir(input, init) {
    var body = init && init.body;
    if (!jsonMu(body)) return asilFetch(input, init);
    var js = JSON.parse(body);
    return sepet().then(function (c) {
      var kalem = js.line ? c.items[js.line - 1] : c.items.find(function (i) { return i.key === js.id || String(i.variant_id) === String(js.id); });
      var mx = kalem && maxAdet(kalem.variant_id);
      var q = parseInt(js.quantity, 10);
      if (mx && !isNaN(q)) {
        var diger = adetSepette(c, kalem.variant_id, kalem.key);
        if (diger + q > mx) {
          js.quantity = Math.max(0, Math.floor((mx - diger) / koli(kalem.variant_id)) * koli(kalem.variant_id));
          uyari(mesaj(kalem.variant_id));
          return asilFetch(input, Object.assign({}, init, { body: JSON.stringify(js) }));
        }
      }
      return asilFetch(input, init);
    });
  }

  // /cart/update — {updates: {<variant_id|key>: qty}} ya da dizi
  function guncelle(input, init) {
    var body = init && init.body;
    if (!jsonMu(body)) return asilFetch(input, init);
    var js = JSON.parse(body);
    if (!js.updates || Array.isArray(js.updates)) return asilFetch(input, init);
    return sepet().then(function (c) {
      var kirpildi = false;
      Object.keys(js.updates).forEach(function (anahtar) {
        var kalem = c.items.find(function (i) { return i.key === anahtar; });
        var vid = kalem ? String(kalem.variant_id) : anahtar.split(':')[0];
        var mx = maxAdet(vid);
        if (!mx) return;
        var diger = adetSepette(c, vid, kalem ? kalem.key : null);
        if (!kalem) diger = 0;
        var q = parseInt(js.updates[anahtar], 10);
        if (diger + q > mx) { js.updates[anahtar] = Math.max(0, Math.floor((mx - diger) / koli(vid)) * koli(vid)); kirpildi = true; }
      });
      if (kirpildi) uyari(mesaj(''));
      return asilFetch(input, kirpildi ? Object.assign({}, init, { body: JSON.stringify(js) }) : init);
    });
  }

  window.fetch = function (input, init) {
    var p = yol(input);
    var m = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (m === 'POST') {
      if (p === '/cart/add') return ekle(input, init);
      if (p === '/cart/change') return degistir(input, init);
      if (p === '/cart/update') return guncelle(input, init);
    }
    return asilFetch(input, init);
  };

  // Sepet sayfası açılışı: sınırı aşan kampanyalı ürün varsa (sepet bağlantısı, eski sepet) sondaki kalemden düşür
  if (/^\/cart\/?$/.test(location.pathname)) {
    sepet().then(function (c) {
      var guncel = {}, asti = false, toplam = {};
      c.items.forEach(function (i) {
        var vid = String(i.variant_id), mx = maxAdet(vid);
        if (!mx) return;
        var once = toplam[vid] || 0, izin = Math.max(0, mx - once);
        izin = Math.floor(izin / koli(vid)) * koli(vid);
        var yeni = Math.min(i.quantity, izin);
        if (yeni !== i.quantity) { guncel[i.key] = yeni; asti = true; }
        toplam[vid] = once + yeni;
      });
      if (!asti) return;
      asilFetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: guncel }) })
        .then(function () { try { sessionStorage.setItem('tt_kampanya_uyari', '1'); } catch (e) {} location.reload(); });
    });
    try {
      if (sessionStorage.getItem('tt_kampanya_uyari')) {
        sessionStorage.removeItem('tt_kampanya_uyari');
        document.addEventListener('DOMContentLoaded', function () { uyari(mesaj('') + ' Sepetiniz buna göre güncellendi.'); });
      }
    } catch (e) {}
  }
})();
